module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-check-fill-9e747f2d.svg";